<template>
    <div>
        <div>
            <select v-model="period_type" class="form-control">
                <option value="last_30_days">{{$t('intern_statistics.last_30_days')}}</option>
                <option value="current_month">{{$t('intern_statistics.current_month')}}</option>
                <option value="last_month">{{$t('intern_statistics.last_month')}}</option>
                <option value="current_year">{{$t('intern_statistics.current_year')}}</option>
                <option value="last_year" v-if="oldest_year <= last_year">{{last_year}}</option>
                <option value="two_years_ago" v-if="oldest_year <= two_years_ago">{{two_years_ago}}</option>
                <option value="date_picker">{{$t('intern_statistics.date_picker')}}</option>
            </select>
        </div>
        <div class="mt-2">
            <div>
                <label>Gewählter Zeitraum</label>
                <date-picker-component v-model="date" :disabled_dates="dateCompare" input_name="date" :readonly="date_readonly" />
            </div>
        </div>
        <div class="mt-2">
            <label for="compare" class="text-muted ml-1 align-middle" @click="clearCompare">
                <font-awesome-icon class="mm-color" :icon="['far', 'check-square']" v-if="compare"/>
                <font-awesome-icon class="mm-color" :icon="['far', 'square']"       v-else/>
                vergleichen
            </label>
        </div>
        <div v-if="compare">
            <select v-model="period_compare_type" class="form-control">
                <template v-if="period_type != 'last_year' && period_type != 'two_years_ago'">
                    <option value="previous_period" v-if="period_type != 'last_month'">{{$t('intern_statistics.previous_period')}}</option>
                    <option value="vormonat" v-if="period_type == 'last_month'">{{$t('intern_statistics.vormonat')}}</option>
                    <option value="previous_year">{{$t('intern_statistics.previous_year')}}</option>
                </template>
                <template v-else-if="period_type == 'last_year'">
                    <template v-for="n in 3">
                        <option
                            v-if="oldest_year <= (last_year - n)"
                            :key="n"
                            :value="'year_' + (last_year - n)"
                        >
                            {{last_year - n}}
                        </option>
                    </template>
                </template>
                <template v-else-if="period_type == 'two_years_ago'">
                    <template v-for="n in 3">
                        <option
                            v-if="oldest_year <= (two_years_ago - n)"
                            :key="n"
                            :value="'year_' + (two_years_ago - n)"
                        >
                            {{two_years_ago - n}}
                        </option>
                    </template>
                </template>
                <option value="date_picker">{{$t('intern_statistics.date_picker')}}</option>
            </select>
            <div class="mt-2">
                <label>Gewählter Vergleichszeitraum</label>
                <date-picker-component v-model="dateCompare" :disabled_dates="date" input_name="dateCompare" :readonly="dateCompare_readonly" />
            </div>
        </div>
        <div class="mt-3 text-right">
            <button class="btn btn-success mr-2" @click="submitPeriod">Übernehmen</button>
        </div>
    </div>
</template>

<script>
    import DatePickerComponent from '../shared/DatePicker';
    import EventBus from '../../EventBus';

    export default {
        data() {
            return {
                date:           this.dates.date,
                dateCompare:    this.dates.dateCompare,
                period_type:    this.dates.period_type,
                period_compare_type:  this.dates.period_compare_type,
                date_readonly:        false,
                dateCompare_readonly: false,
                compare:        false,
                oldest_year:    new Date().getFullYear(),
                last_year:      new Date().getFullYear() - 1,
                two_years_ago:  new Date().getFullYear() - 2,
            }
        },
        props: {
            dates: {
                type: Object,
                default() {
                    return {
                        date:        {},
                        dateCompare: {},
                        period_type: '',
                        period_compare_type: ''
                    }
                }
            }
        },
        watch: {
            dates(val) {
                this.date        = val.date;
                this.dateCompare = val.dateCompare;
                this.period_type = val.period_type;

                this.period_compare_type = val.period_compare_type;

                if(Object.keys(this.dateCompare).length > 0 || this.period_compare_type != ''){
                    this.compare = true;
                }
            },
            period_type(val, old_val) {
                this.updateDate(val);
                if(val == 'date_picker') {
                    EventBus.$emit('OPEN_CALENDAR', 'date');
                }

                if(this.period_compare_type) {
                    this.updateDateCompare(this.period_compare_type);
                }
            },
            period_compare_type(val) {
                this.updateDateCompare(val);
                if(val == 'date_picker') {
                    EventBus.$emit('OPEN_CALENDAR', 'dateCompare');
                }
            },
            compare(val) {
                if(val && !this.period_compare_type) {
                    this.period_compare_type = 'date_picker';
                }
            }
        },
        model: {
            prop: 'dates',
            event: 'modified'
        },
        components: {
            DatePickerComponent
        },
        methods: {
            clear() {
                this.date = this.dateCompare = {};
            },
            clearCompare() {
                this.compare = !this.compare;
                if(!this.compare) {
                    this.dateCompare = {};
                    this.period_compare_type = '';
                }
            },
            getOldestObjectYear() {
                this.$http.get('/statisticsApi/getOldestObjectYear').then(response => {
                    if(response.data){
                        this.oldest_year = parseInt(response.data);
                    }
                }).catch(err => {
                    console.log(err);
                });
            },
            isValidDate(period_type, date) {
                if(period_type == 'date_picker'){
                    if(date && Object.keys(date).length > 0) {
                        return true;
                    } else {
                        this.$bvToast.toast(this.$t('intern_meldung.date_picker_empty'), {
                            variant: 'danger',
                            title:   'Fehlermeldung'
                        });
                        return false;
                    }
                }

                return true;
            },
            submitPeriod() {
                if(!this.isValidDate(this.period_type, this.date)) {
                    return false;
                }

                if(this.compare) {
                    if(!this.isValidDate(this.period_compare_type, this.dateCompare)) {
                        return false;
                    }
                }

                let date = {
                    period_type:         this.period_type,
                    period_compare_type: this.period_compare_type,
                    date:                this.period_type == 'date_picker' ? this.date : {},
                    dateCompare:         this.period_compare_type == 'date_picker' ? this.dateCompare : {},
                };
                this.$emit('modified', date);
            },
            updateDate(val, isCreated = false) {
                let date  = new Date();
                let start = new Date();
                let end   = new Date();

                switch(val) {
                    case 'last_30_days':
                        start.setDate(date.getDate() - 30);
                        end.setDate(date.getDate() - 1);

                        if(isCreated) {
                          setTimeout(()=> {
                            this.date = {
                              start: start,
                              end: end
                            };
                          });
                        }
                        else {
                           this.date = {
                                  start: start,
                                  end: end
                            };
                        }
                        this.date_readonly = true;
                        break;
                    case 'current_month':
                        start.setDate(1);

                        if(isCreated) {
                          setTimeout(()=> {
                            this.date = {
                              start: start,
                              end: end
                            };
                          });
                        }
                        else {
                          this.date = {
                              start: start,
                              end: end
                          };
                        }
                        this.date_readonly = true;
                        break;
                    case 'last_month':
                        start.setDate(1);
                        start.setMonth(start.getMonth() - 1);

                        end.setDate(new Date(end.getFullYear(), end.getMonth(), 0).getDate());
                        end.setMonth(end.getMonth() - 1);

                        if(isCreated) {
                          setTimeout(()=> {
                            this.date = {
                              start: start,
                              end: end
                            };
                          });
                        }
                        else {
                          this.date = {
                            start: start,
                            end: end
                          };
                        }
                        this.date_readonly = true;
                        break;
                    case 'current_year':
                        start.setDate(1);
                        start.setMonth(0);

                        if(isCreated) {
                          setTimeout(()=> {
                            this.date = {
                              start: start,
                              end: end
                            };
                          });
                        }
                        else {
                          this.date = {
                              start: start,
                              end: end
                          };
                        }
                        this.date_readonly = true;
                        break;
                    case 'last_year':
                        start.setDate(1);
                        start.setMonth(0);
                        start.setFullYear(start.getFullYear() - 1);

                        end.setDate(31);
                        end.setMonth(11);
                        end.setFullYear(end.getFullYear() - 1);

                        if(isCreated) {
                          setTimeout(()=> {
                            this.date = {
                              start: start,
                              end: end
                            };
                          });
                        }
                        else {
                          this.date = {
                            start: start,
                            end: end
                          };
                        }
                        this.date_readonly = true;
                        break;
                    case 'two_years_ago':
                        start.setDate(1);
                        start.setMonth(0);
                        start.setFullYear(start.getFullYear() - 2);

                        end.setDate(31);
                        end.setMonth(11);
                        end.setFullYear(end.getFullYear() - 2);

                        if(isCreated) {
                          setTimeout(()=> {
                            this.date = {
                              start: start,
                              end: end
                            };
                          });
                        }
                        else {
                          this.date = {
                            start: start,
                            end: end
                          };
                        }
                        this.date_readonly = true;
                        break;
                    case 'date_picker':
                        if(isCreated) {
                          setTimeout(()=> {
                            this.date = {
                              start : this.dates.date.start,
                              end : this.dates.date.end
                            };
                          });
                        }
                        else {
                            //this.date = {};
                        }
                        this.date_readonly = false;

                        break;
                }
            },
            updateDateCompare(val, isCreated) {

                let start = new Date();
                let end   = new Date();

                let year_arr = val.split('_');

                if(year_arr[0] == 'year') {
                    start.setDate(1);
                    start.setMonth(0);
                    start.setFullYear(year_arr[1]);

                    end.setDate(31);
                    end.setMonth(11);
                    end.setFullYear(year_arr[1]);

                    if(isCreated) {
                      setTimeout(()=> {
                        this.dateCompare = {
                          start : start,
                          end : end
                        };
                      });
                    }
                    else {
                      this.dateCompare = {
                        start: start,
                        end: end
                      };
                    }
                }

                switch(val) {
                    case 'previous_period':
                        let time_diff = Math.abs(this.date.end - this.date.start);
                        let days = time_diff / (24 * 60 * 60 * 1000);
                        let date = (this.date.start.getTime() > this.date.end.getTime()) ? 'end' : 'start';

                        end.setTime(this.date[date].getTime() - (24 * 60 * 60 * 1000));
                        start.setTime(this.date[date].getTime() - time_diff - (24 * 60 * 60 * 1000));

                        if(isCreated) {
                          setTimeout(()=> {
                            this.dateCompare = {
                              start : start,
                              end : end
                            };
                          });
                        }
                        else {
                          this.dateCompare = {
                            start: start,
                            end: end
                          };
                        }
                        this.dateCompare_readonly = true;
                        break;
                    case 'previous_year':

                        start.setDate(this.date.start.getDate());
                        start.setMonth(this.date.start.getMonth());
                        start.setFullYear(this.date.start.getFullYear() - 1);

                        end.setDate(this.date.end.getDate());
                        end.setMonth(this.date.end.getMonth());
                        end.setFullYear(this.date.end.getFullYear() - 1);

                        if(isCreated) {
                          setTimeout(()=> {
                            this.dateCompare = {
                              start : start,
                              end : end
                            };
                          });
                        }
                        else {
                          this.dateCompare = {
                            start: start,
                            end: end
                          };
                        }
                        this.dateCompare_readonly = true;
                        break;
                    case 'vormonat':
                        start.setDate(1);
                        start.setMonth(start.getMonth() - 2);

                        end.setDate(new Date(start.getFullYear(), start.getMonth() + 1, 0).getDate());
                        end.setMonth(end.getMonth() - 2);

                        if(isCreated) {
                          setTimeout(()=> {
                            this.dateCompare = {
                              start : start,
                              end : end
                            };
                          });
                        }
                        else {
                          this.dateCompare = {
                            start: start,
                            end: end
                          };
                        }
                        this.dateCompare_readonly = true;
                        break;
                    case 'date_picker':
                        if(isCreated) {
                          setTimeout(()=> {
                            this.dateCompare = {
                              start : this.dates.dateCompare.start,
                              end : this.dates.dateCompare.end
                            };
                          });
                        }
                        else {
                          //this.dateCompare = {};
                        }
                        this.dateCompare_readonly = false;

                        break;
                }
            }
        },
        created() {
            this.getOldestObjectYear();
            this.compare =
                    (this.dateCompare && Object.keys(this.dateCompare).length > 0)
                    ||
                    (this.period_compare_type != '')
                    ? true : false;

            this.period_compare_type = this.dates.period_compare_type;
            this.period_type         = this.dates.period_type == '' ? 'current_month' : this.dates.period_type;

            setTimeout(()=>{
              this.updateDate(this.period_type, true);
            });
            setTimeout(()=>{
              this.updateDateCompare(this.period_compare_type, true);
            },200);
        }
    }
</script>

<style scoped>

</style>
